import React, { useEffect, useState } from "react";
import { GridToolbar } from "@material-ui/data-grid";
import { makeGETRequestOnUserService } from "../../Api/api";
import { RouteComponentProps } from "react-router-dom";
import toastr from "toastr";
import { Box, Button } from "@mui/material";
import { RFQOrdersList } from "../RFQOrders/interfaces";
import { convertToCamelCase } from "../RFQOrders/utilities";
import { StyledDataGrid } from "../RFQOrders/RFQOrders";
import EditIcon from "@material-ui/icons/Edit";
import moment from "moment";

export const dataGridCells = [
  //   { field: "uuid", headerName: "UUID", width: 300, editable: false },
  {
    field: "source",
    headerName: "Source",
    width: 200,
    editable: false,
    renderCell: (params: any) => {
      const source = params.row?.source;
      if (!source) return "";
      if (source.type === "smest") {
        return `${source.name || ""} ${(source.type || "").toUpperCase()}`;
      }
      if (source.type === "partner") {
        return `Self (${source.company_name || source.name || ""})`;
      }
      if (source.type === "client") {
        return `Client (${source.company_name || source.name || ""})`;
      }
      return "";
    }
  },
  {
    field: "insertedAt",
    headerName: "Date",
    width: 200,
    editable: false,
    renderCell: (params: any) => {
      const rowData = params.row;
      return moment(rowData.insertedAt).format("(HH[H]:mm[M]) MMM DD, YYYY");
    },
  },
  {
    field: "settlementDate",
    headerName: "Settlement Date",
    width: 200,
    editable: false,
  },
  { field: "isin", headerName: "ISIN", width: 150, editable: false },
  {
    field: "securityName",
    headerName: "Security Name",
    width: 200,
    editable: false,
  },
  {
    field: "noOfBonds",
    headerName: "No. of Bonds",
    width: 200,
    editable: false,
  },
  {
    field: "sellerName",
    headerName: "Seller Name",
    width: 200,
    editable: false,
  },
  {
    field: "paymentProcess",
    headerName: "Payment Mode",
    width: 200,
    editable: false,
  },
  {
    field: "newPage",
    headerName: "New Page",
    sortable: false,
    width: 150,
    disableClickEventBubbling: true,
    renderCell: () => {
      return (
        <EditIcon
          color="error"
          fontSize="medium"
          style={{
            float: "left",
            marginLeft: "10px",
            marginTop: "14px",
            cursor: "pointer",
          }}
        />
      );
    },
  },
  {
    field: "status",
    headerName: "Status",
    valueGetter: (params: any) => params.row.dealStatus,
    sortable: false,
    width: 200,
    disableClickEventBubbling: true,
    renderCell: (params: any) => {
      const rowData = params.row;
      return (
        <Button
          fullWidth
          variant="outlined"
          color={
            rowData.dealStatus === "Pending"
              ? "warning"
              : rowData.dealStatus === "Confirmed"
                ? "secondary"
                : rowData.dealStatus === "Cancelled"
                  ? "error"
                  : "success"
          }
        >
          {rowData.dealStatus}
        </Button>
      );
    },
  },
];

const RFQSellOrders: React.FC<RouteComponentProps> = (props) => {
  const [rfqOrders, setRfqOrders] = useState<RFQOrdersList[]>([]);

  useEffect(() => {
    makeGETRequestOnUserService("order_management_v2/client/order_lists/?type=all")
      .then((resp) => {
        if (resp.status === 200) {
          setRfqOrders(
            convertToCamelCase<RFQOrdersList>([...resp.data, ...rfqOrders])
              .filter(
                (item) =>
                  JSON.parse(localStorage.getItem("loginUser")!)?.isSuperuser ||
                  JSON.parse(localStorage.getItem("loginUser")!)?.can_see_all ||
                  item.leadowner ===
                  JSON.parse(localStorage.getItem("loginUser")!)?.name
              )
              .sort((a, b) => {
                const dateA = new Date(a.insertedAt);
                const dateB = new Date(b.insertedAt);
                return dateB.getTime() - dateA.getTime();
              })
          );
        } else {
          toastr.error("Something went wrong");
        }
      })
      .catch((error) => toastr.error(error));
  }, []);

  function handleCellClick(params: any) {
    if (params.field === "newPage") {
      props.history.push(`/rfq_sell_order/${params.row.uuid}/${params.row.source.type}`);
    }
  }

  return (
    <Box sx={{ height: "100%", width: "100%", px: [2, 10], py: 1 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2>RFQ Sell Orders</h2>
        <Button
          variant="contained"
          color="primary"
          sx={{ px: 2, py: 0.5, height: "fit-content" }}
          onClick={() => props.history.push("/create_rfq_sell_order")}
        >
          Create RFQ Sell Order
        </Button>
      </Box>
      <StyledDataGrid
        pagination
        components={{ Toolbar: GridToolbar }}
        rows={rfqOrders}
        columns={dataGridCells}
        onCellClick={handleCellClick}
        getRowId={(rfqOrder) => rfqOrder.uuid}
        autoHeight
        getRowClassName={(params) => {
          const { dealStatus } = params.row;
          if (dealStatus === "Pending") return "row-pending";
          if (dealStatus === "Confirmed") return "row-confirmed";
          if (dealStatus === "Cancelled") return "row-cancelled";
          return "row-default";
        }}
      />
    </Box>
  );
};

export default RFQSellOrders;
